var map = {
	"./avatar_image_bg.svg": "445b",
	"./avatar_level.svg": "3a35",
	"./avatar_name.svg": "2b0b",
	"./avatar_progress.svg": "175e",
	"./background_field.svg": "378d",
	"./banner_blue.svg": "372c",
	"./banner_correct.svg": "c53d",
	"./banner_correct_text.svg": "5a2d",
	"./banner_home_left.svg": "c62d",
	"./banner_home_right.svg": "c322",
	"./banner_incorrect.svg": "6763",
	"./banner_incorrect_text.svg": "1c1e",
	"./banner_orange.svg": "8956",
	"./banner_points.svg": "d4d3",
	"./banner_tail.svg": "6578",
	"./bunny_sit.svg": "e94d",
	"./bunny_string.svg": "4d37",
	"./bunny_string_short.svg": "f599",
	"./button_exit.svg": "7a0e",
	"./button_settings.svg": "e456",
	"./button_sound.svg": "beb1",
	"./button_sound_muted.svg": "114b",
	"./button_speech.svg": "dbc4",
	"./button_speech_muted.svg": "3d21",
	"./cloud.svg": "dd58",
	"./cloud_medium.svg": "a8ac",
	"./cloud_small.svg": "a621",
	"./duck.svg": "09f5",
	"./duck_dim.svg": "4f31",
	"./egg_circles.svg": "e057",
	"./egg_circles_happy.svg": "789d",
	"./egg_circles_sad.svg": "e0f9",
	"./egg_clouds.svg": "b527",
	"./egg_clouds_happy.svg": "9bbc",
	"./egg_clouds_sad.svg": "7665",
	"./egg_crowns.svg": "236d",
	"./egg_crowns_happy.svg": "209c",
	"./egg_crowns_sad.svg": "432d",
	"./egg_fish.svg": "628e",
	"./egg_fish_happy.svg": "f87d",
	"./egg_fish_sad.svg": "a29b",
	"./egg_flowers.svg": "64ea",
	"./egg_flowers_happy.svg": "0ad3",
	"./egg_flowers_sad.svg": "ad0d",
	"./egg_hearts.svg": "577f",
	"./egg_hearts_happy.svg": "7057",
	"./egg_hearts_sad.svg": "4867",
	"./egg_melons.svg": "5ef7",
	"./egg_melons_happy.svg": "f152",
	"./egg_melons_sad.svg": "1e8a",
	"./egg_planes.svg": "d13c",
	"./egg_planes_happy.svg": "2761",
	"./egg_planes_sad.svg": "1ffd",
	"./egg_plant.svg": "07f4",
	"./egg_plant_happy.svg": "dd60",
	"./egg_plant_sad.svg": "1d67",
	"./egg_spirals.svg": "edeb",
	"./egg_spirals_happy.svg": "f4ec",
	"./egg_spirals_sad.svg": "db51",
	"./egg_squares.svg": "6b00",
	"./egg_squares_happy.svg": "abd5",
	"./egg_squares_sad.svg": "e64c",
	"./egg_stars.svg": "25d6",
	"./egg_stars_happy.svg": "8878",
	"./egg_stars_sad.svg": "d96c",
	"./flower.svg": "a493",
	"./life.svg": "f21f",
	"./life_dim.svg": "701c",
	"./mute.svg": "ad8d",
	"./paper_plane_solo.svg": "8483",
	"./plane_correct.svg": "d5d2",
	"./plane_incorrect.svg": "8777",
	"./plane_orange.svg": "d8a9",
	"./settings_background.svg": "cbb5",
	"./speaker.svg": "48f5",
	"./star.svg": "5b71",
	"./star_dim.svg": "9c7f",
	"./stroke_font.svg": "05ef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "97bf";